import { render, staticRenderFns } from "./Bidhours.vue?vue&type=template&id=5c35be5c&"
import script from "./Bidhours.vue?vue&type=script&lang=js&"
export * from "./Bidhours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports